/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { List, ListItem, Button, colors ,Avatar, Badge} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {},
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: '#7f8fa6',
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    fontWeight: theme.typography.fontWeightMedium,
  },
  customBadge: {
    backgroundColor: "#6A3053",
    color: "white"
  },
  icon: {
    color: '#7f8fa6',
    width:30,
    height: 30,
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "& $icon": {
      color: theme.palette.primary.main,
    },
    customBadge: {
      backgroundColor: "#00AFD7",
      color: "white"
    }
  },
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const SidebarNav = (props) => {
  const {onClose, pages, className, ...rest } = props;

  const classes = useStyles();
  const [ToggleStatus, setToggleStatus] = useState(true);

  useEffect(
    () => {
      let timer1 = 
      setTimeout(() => {
        setToggleStatus(!ToggleStatus)
  
      }, 300);

      // this will clear Timeout
      // when component unmount like in willComponentUnmount
      // and show will not change to true
      return () => {
        clearTimeout(timer1);
      };
    },
    // useEffect will run only one time with empty []
    // if you pass a value to array,
    // like this - [data]
    // than clearTimeout will run every time
    // this value changes (useEffect re-run)
    [ToggleStatus]
  );

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map((page) => (
        <ListItem className={classes.item} disableGutters key={page.title}>
      

          <Button
            activeClassName={classes.active}
            className={classes.button}
            component={CustomRouterLink}
            to={page.href}
            onClick={onClose}
          > 


{page.title=='لیست درخواست ها'?
                <Badge  anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
    
                }} 
                classes={{ badge: classes.customBadge }}
                variant="dot" invisible={ToggleStatus}>
                <div className={classes.icon}>{page.icon}</div>
    
                </Badge>:   
            <div className={classes.icon}>{page.icon}</div>

          }
            
            {page.title}
           
           

          </Button>
        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired,
};

export default SidebarNav;
